import React from "react";
import DashboardStats from "../../components/admin/DashboardStats";

const Dashboard = () => {
  const currentDate = new Date().toLocaleDateString("vi-VN");
  const fullName = localStorage.getItem("full_name") || "bạn";
  const isApproved = localStorage.getItem("isApproved") === "true";

  return (
    <div className="p-4 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          {/* {isApproved && <h1 className="text-[24px] font-bold">Tổng quan</h1>} */}
          <p className="text-gray-500">
            Chào mừng <strong>{fullName}</strong> trở lại! Hôm nay là ngày{" "}
            {currentDate}
          </p>
        </div>
      </div>
      {isApproved && <DashboardStats />}
    </div>
  );
};

export default Dashboard;
